import { Button } from "@sylviq/ui-react-web/components/ui/button";
import { Link } from "@tanstack/react-router";
import { destinationSearch } from "@/shell/destination-search";

export function ReportBackButton() {
  return (
    <Button asChild variant="secondary">
      <Link
        to="/reports"
        search={(previous) => destinationSearch(previous, {})}
      >
        Back to reports
      </Link>
    </Button>
  );
}
